export function getLMSStudentName() {
  try {
    const params = new URLSearchParams(window.location.search);
    const urlName = params.get("learner_name");
    if (urlName) {
      return urlName.trim();
    }
  } catch (e) {}

  function findAPI(win) {
    let attempts = 0;
    try {
      while (win && !win.API && !win.API_1484_11 && win.parent && win.parent !== win && attempts < 10) {
        win = win.parent;
        attempts++;
      }
      return win ? (win.API || win.API_1484_11) : null;
    } catch (e) {
      return null;
    }
  }

  try {
    const api = findAPI(window) || (window.opener ? findAPI(window.opener) : null);
    if (api) {
      let name = "";
      if (typeof api.LMSGetValue === "function") {
        // SCORM 1.2
        name = api.LMSGetValue("cmi.core.student_name");
      } else if (typeof api.GetValue === "function") {
        // SCORM 2004
        name = api.GetValue("cmi.learner_name");
      }

      if (name && name !== "null" && name !== "undefined") {
        name = name.trim();
        // LMS names are often formatted as "LastName, FirstName"
        if (name.includes(",")) {
          const parts = name.split(",");
          return (parts[1].trim() + " " + parts[0].trim()).trim();
        }
        return name;
      }
    }
  } catch (e) {
    console.error("Failed to read name from SCORM LMS API:", e);
  }
  return null;
}
